<template>
<v-card tile width="auto">
  <v-card-text class="py-2">
    <v-row dense>
      <v-btn class="pa-4" color="success" @click="exportData({})" dark>Descargar Layout</v-btn>
      <v-col cols="12" v-if="showLoad">
          <ImportData :on-success="handleSuccess" :before-upload="beforeUpload"/>
      </v-col>
      <v-col cols="12" v-if="showMessage">
        <v-alert border="top" color="green" type="success" class="ma-2"> {{message}} </v-alert>
      </v-col>
      <v-col cols="12" v-if="showTable">
        <DataTableMain :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
      </v-col>
    </v-row>
  </v-card-text>
  <v-card-actions>
    <v-layout justify-end>
      <v-btn class="mr-3" color="red darken-1" depressed outlined @click="onCancel">CERRAR</v-btn>
      <v-btn class="mr-3" color="success darken-1" depressed outlined @click="sendForm">IMPORTAR</v-btn>
    </v-layout>
  </v-card-actions>
</v-card>
</template>

<script>
import ImportData from '@/components/ImportData'
import DataTableMain from '@/components/tables/DataTableMain'
import XLSX from 'xlsx'
export default {
  props: ['itemAction', 'model', 'onSuccess', 'onCancel'],
  data: () => ({
    table: {
      header: { options: [], titles: [], loading: false },
      body: { data: [], actions: [] },
      footer: { paging: true }
    },
    name: 'default',
    field: null,
    showLoad: true,
    showMessage: false,
    showTable: false,
    message: '',
    results: [],
    layout: [],
    form: {}
  }),
  components: {
    ImportData,
    DataTableMain
  },
  methods: {
    successAction (item) {
      this[item.action](item)
    },
    LoadData (item) {
      console.log('item', item)
      this.showLoad = true
      item.code = 'no-libre'
      item.hidden = 'no-libre'
    },
    exportData (item) {
      const dataExample = {}
      // console.log(this.itemAction)
      this.table.header.titles.map(item => {
        dataExample[item.value] = item.text
      })
      this.layout.push(dataExample)
      const format = this.name
      const data = XLSX.utils.json_to_sheet(this.layout)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, data, format)
      XLSX.writeFile(workbook, `${format}.xlsx`)
    },
    tableAction (item) {
      this[item.action](item)
    },
    beforeUpload (file) {
      const isLt1M = file.size / 1024 / 1024 < 20
      if (isLt1M) {
        this.showLoad = false
        // this.itemAction.status_finish.formulario.table.header.options[0].code = 'libre'
        // this.itemAction.status_finish.formulario.table.header.options[0].hidden = ''
        return true
      }
      this.$swal({
        type: 'warning',
        icon: 'warning',
        title: 'Advertencia !',
        text: `${isLt1M} No cargue archivos de más de 1 MB de tamaño.`
      })
      return false
    },
    handleSuccess (excelData) {
      console.log('excelData', excelData)
      if (excelData.Numberpage === 1) {
        this.message = `se agrego 1 pestaña con ${excelData[excelData.page[0]].results.length} Registros`
      } else {
        let rows = 0
        excelData.page.map(name => {
          rows += excelData[name].results.length
        })
        this.message = `se agrego ${excelData.Numberpage} pestañas, total de regisros ${rows}`
      }
      this.showMessage = true
      this.results = excelData[excelData.page[0]].results
      // console.log('this', this.table)
      this.table.body.data = this.results
      this.showTable = true
      this.model[this.field.nameid] = this.results
    },
    sendForm () {
      this.onSuccess({
        descripcion: this.model,
        action: this.itemAction.accion,
        status: this.itemAction.estatus_final_id,
        actual: this.itemAction.estatus_actual_id
      })
    }
  },
  watch: {
    itemAction (item) {
      // console.log('item', item)
      this.field = item.status_finish.formulario.fields
      this.table = item.status_finish.formulario.fields.table
      this.name = item.status_finish.formulario.fields.name
    }
  }
}
</script>

<style>

</style>
